import {破棄破損修正候補編集レコード型} from '@/type/destroy/records/modify/破棄破損修正候補編集レコード型';

export interface 破棄破損削除依頼型 {
  破棄破損シーケンス番号: number | null;
  更新バージョン: number | null;
}

export function to破棄破損削除依頼型(record: 破棄破損修正候補編集レコード型): 破棄破損削除依頼型 {
  return {
    破棄破損シーケンス番号: record.元レコード.破棄破損シーケンス番号,
    更新バージョン: record.元レコード.更新バージョン,
  };
}
